import {
  removeAllVuePreloadHiddenClasses,
  removeAllVuePostloadHiddenElements
} from './util';
import './components/product-matrix';

removeAllVuePreloadHiddenClasses('#as_product_matrix');
removeAllVuePostloadHiddenElements('#as_product_matrix');
